/**
 * Console.log the data section for dev debugger.
 */
export const Log = () => {
    return (data) => {
        console.log('G2 data section:', data);
        return data;
    };
};
Log.props = {};
//# sourceMappingURL=log.js.map